import { Constructor } from '~/lib/ytil'
import { SVGName } from '~/ui/components/SVG'
import { BeWizrCourse } from './BeWizrCourse'
import { BeWizrLearningTrack } from './BeWizrLearningTrack'
import { BeWizrMeeting } from './BeWizrMeeting'
import { BeWizrEmbedItem, BeWizrLinkItem, BeWizrMediaItem } from './BeWizrMiscItem'
import { BeWizrModel } from './BeWizrModel'

export class BeWizrLibraryTopic extends BeWizrModel {

  title!: string

  slug!: string

  itemCount!: number

  links!: {
    image: string | null
  }

  protected afterDeserialize() {
    this.id = this.slug
  }

}

export class BeWizrLibraryCategory extends BeWizrLibraryTopic {

  topic!: BeWizrLibraryTopic

  protected afterDeserialize() {
    this.id    = this.slug
    this.topic = BeWizrLibraryTopic.deserialize({
      title: this.raw.topicTitle,
      slug:  this.raw.topicSlug,
    })
  }
}

export type BeWizrLibraryItem = BeWizrCourse | BeWizrLearningTrack | BeWizrMeeting | BeWizrLinkItem | BeWizrEmbedItem | BeWizrMediaItem

export type BeWizrLibraryItemType = 'course' | 'learning_track' | 'meeting' | 'linkitem' | 'embeditem' | 'mediaitem'

export const BeWizrLibraryItemType: {
  all:          BeWizrLibraryItemType[]
  iconForType:  (type: BeWizrLibraryItemType) => SVGName
  ModelForType: (type: BeWizrLibraryItemType) => Constructor<BeWizrModel> | null
  typeForModel: (model: BeWizrLibraryItem)    => BeWizrLibraryItemType
} = {
  all: ['course', 'learning_track', 'meeting', 'embeditem', 'mediaitem', 'linkitem'],
  iconForType: (type) => {
    switch (type) {
      case 'course':
        return 'course'
      case 'learning_track':
        return 'unordered-list'
      case 'meeting':
        return 'meeting'
      case 'embeditem':
        return 'video'
      case 'mediaitem':
        return 'image'
      case 'linkitem':
        return 'link'
    }
  },
  ModelForType: type => {
    switch (type) {
      case 'course':
        return BeWizrCourse
      case 'learning_track':
        return BeWizrLearningTrack
      case 'meeting':
        return BeWizrMeeting
      case 'embeditem':
        return BeWizrEmbedItem
      case 'mediaitem':
        return BeWizrMediaItem
      case 'linkitem':
        return BeWizrLinkItem
      default:
        return null
    }
  },
  typeForModel: model => {
    if (model instanceof BeWizrCourse) {
      return 'course'
    } else if (model instanceof BeWizrLearningTrack) {
      return 'learning_track'
    } else if (model instanceof BeWizrMeeting) {
      return 'meeting'
    } else if (model instanceof BeWizrEmbedItem) {
      return 'embeditem'
    } else if (model instanceof BeWizrMediaItem) {
      return 'mediaitem'
    } else {
      return 'linkitem'
    }
  },
}